import { Logo } from "assets";
import Navigation from "../navigation.svg";
import Thanks from "../thanks.svg";
import Error from "../error.svg";
import MailB from "../mail-b.svg";
import Phone from "../phone.svg";
import { RoundGreyPlain } from "components/ui/Buttons/generic/GenericButton";

export default function MessageReport({hasErrors= false, lostMail= false}: {hasErrors?: boolean, lostMail?: boolean}){
    return(
        <>
        <div className="md:h-[100vh] w-full flex flex-col gap-0 items-stretch">
            <ThanksHeader/>
            {
            lostMail ?
                <LostMailBody hasErrors={hasErrors}/>
                :
                <ThanksBody hasErrors={hasErrors}/>
            }
        </div>
        </>
    );
};

const ThanksHeader= ()=> {
    return(
        <>
            <div className="flex items-center justify-center bg-white py-[25px]">
                <img src={Logo} alt="WOS-LOGO" className="w-[140px]"/>
            </div>
        </>
    );
}

const ThanksBody= ({hasErrors= false}) => {
    return(<>
        <div className="flex flex-col items-center flex-[1] lg:gap-[89px] gap-[40px] justify-center bg-[#f4f4f5] w-full lg:p-0 md:p-0 md:py-[100px] py-[117px]">
            <div className="flex flex-col gap-[30px] md:max-w-[672px] max-w-[90vw] w-full">
                <img src={hasErrors ? Error : Thanks} alt="PHONE" className="w-[60px]"/>
                <h1 className="text-[30px] leading-[36px] font-semibold text-[#1d1d39]">{hasErrors ? "Une erreur est survenue." : "Merci ! Votre demande a bien été envoyée :)"}</h1>
                <p className="text-[20px] leading-[24px] font-normal text-[#6f6f6f]">{hasErrors ? "Nous sommes désolés, votre formulaire n’a pas pu être envoyé. Veuillez réessayer dans quelques instants ou nous contacter directement si le problème persiste." : "Notre équipe l’a bien reçu et vous répondra dans les plus brefs délais."}</p>
                <RoundGreyPlain text="Retourner sur le site" to={"/"} className="px-[27px] py-[13.5px] font-semibold text-[18px] leading-[23.44px]" isButton={false}/>
            </div>
            <ContactCard />
        </div>
    </>);
};

const LostMailBody= ({hasErrors= false}) => {
    return(<>
        <div className="flex flex-col items-center flex-[1] lg:gap-[89px] gap-[40px] justify-center bg-[#f4f4f5] w-full lg:p-0 md:p-0 md:py-[100px] py-[117px]">
            <div className="flex flex-col gap-[30px] md:max-w-[672px] max-w-[90vw] w-full">
                <img src={hasErrors ? Error : Thanks} alt="PHONE" className="w-[60px]"/>
                <h1 className="text-[30px] leading-[36px] font-semibold text-[#1d1d39]">{hasErrors ? "Désolé. L'adresse n'est pas reconnue" : "Votre demande a bien été prise en compte"}</h1>
                <p className="text-[20px] leading-[24px] font-normal text-[#6f6f6f]">{hasErrors ? "L'adresse que vous avez fournie n'est pas enregistrée sur Wall of Share. Veuillez revérifier." : "Vous allez bientôt recevoir un email pour réinitialiser votre mot de passe."}</p>
                <RoundGreyPlain text="Retourner sur le site" to={"/"} className="px-[27px] py-[13.5px] font-semibold text-[18px] leading-[23.44px]" isButton={false}/>
            </div>
            <ContactCard />
        </div>
    </>);
};

const ContactCard= () => {
    return(    
    <div className="rounded-[20px] bg-white p-[30px] flex flex-col gap-[15px] md:max-w-[672px] max-w-[90vw] w-full">
        <div className="flex md:flex-row flex-col gap-[10px]">
            <img src={Navigation} alt="NAV" className="w-[20px]"/>
            <p className="text-[20px] leading-[24px] text-[#6f6f6f] font-normal">198 avenue de Verdun 92130, Issy les Moulineaux</p>
        </div>
        <div className="flex md:flex-row flex-col gap-[10px]">
            <img src={MailB} alt="NAV" className="w-[20px]"/>
            <p className="text-[20px] leading-[24px] text-[#6f6f6f] font-normal">contact@wall-of-share.com</p>
        </div>
        <div className="flex md:flex-row flex-col gap-[10px]">
            <img src={Phone} alt="NAV"className="w-[20px]" />
            <p className="text-[20px] leading-[24px] text-[#6f6f6f] font-normal">+33 1 84 14 06 19</p>
        </div>
    </div>
    )
};